module.exports = __webpack_public_path__ + "img/healthPro1-EN.8c6af04d.png";